import { baseApi } from "./baseApi";

const DRIVER_TRANSFER_REQUEST_BASE_URL = "/driver-transfer-request";

export const driverTransferRequestApi = baseApi.injectEndpoints({

  tagTypes: ["DriverTransferRequest"],
  endpoints: (build) => ({
    listDriverTransferRequests: build.query({
      query: (params) => ({
        url: DRIVER_TRANSFER_REQUEST_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "DriverTransferRequest",
                id: _id,
              })),
              { type: "DriverTransferRequest", id: "LIST" },
            ]
          : [{ type: "DriverTransferRequest", id: "LIST" }],
    }),

    exportDriverTransferRequests: build.query({
      query: (params) => ({
        url: `${DRIVER_TRANSFER_REQUEST_BASE_URL}/export`,
        params,
      }),
    }),

    getDriverTransferRequestDetail: build.query({
      query: (id) => `${DRIVER_TRANSFER_REQUEST_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "DriverTransferRequest", id },
      ],
    }),
  }),
});

export const {
  useLazyListDriverTransferRequestsQuery,
  useLazyExportDriverTransferRequestsQuery,
  useGetDriverTransferRequestDetailQuery,
} = driverTransferRequestApi;